module.exports = __webpack_public_path__ + "img/Robust Coffees.78d01d9a.jpg";